// Get tags from post content
export var detectTags = function (content, character) {
    return content.split(' ').filter(function (word) {
        return (word.slice(0, 1) === character);
    });
};
export var getContentTags = function (content) {
    var newTags = [];
    var tags = detectTags(content, '#');
    tags.forEach(function (tag) {
        newTags.push(tag.slice(1));
    });
    return newTags;
};
export var sortObjectsDate = function (objects) {
    var sortedObjects = objects;
    // Sort posts with creation date
    sortedObjects.sort(function (a, b) {
        return parseInt(b.creationDate, 10) - parseInt(a.creationDate, 10);
    });
    return sortedObjects;
};
export var sortImuObjectsDate = function (objects) {
    var sortedObjects = objects;
    // Sort posts with creation date
    return sortedObjects.sort(function (a, b) {
        return parseInt(b.get('creationDate'), 10) - parseInt(a.get('creationDate'), 10);
    });
    // return sortedObjects
};
export var sortImuObjectsAvailable = function (objects) {
    var sortedObjects = objects;
    // Sort posts with creation date
    return sortedObjects.sort(function (a, b) {
        console.log(a.get('available'));
        return (b.get('available')) - (a.get('available'));
    });
    // return sortedObjects
};



//////////////////
// WEBPACK FOOTER
// ./src/api/PostAPI.ts
// module id = 973
// module chunks = 0 1 2 3 4 5 6 7